import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { SEO } from "@/components/common/SEO";
import { COMPANY } from "@/i18n/translations";

export default function Terms() {
  const { t } = useLang();
  const sections = t("terms.sections");

  return (
    <div data-testid="terms-page">
      <SEO title={`${t("terms.title")} | ${COMPANY.brand}`} description={t("terms.intro")} />
      <section className="bg-white py-20 lg:py-28">
        <div className="container-orion max-w-3xl">
          <div className="text-eyebrow">{t("footer.legal")}</div>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl tracking-tighter font-medium leading-tight text-slate-900">
            {t("terms.title")}
          </h1>
          <p className="mt-3 text-sm text-slate-500">{t("terms.lastUpdated")}</p>
          <p className="mt-8 text-slate-600 leading-relaxed">{t("terms.intro")}</p>
          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-heading text-xl font-medium text-slate-900">{s.heading}</h2>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
